import { render } from "./Chrono.vue?vue&type=template&id=f87121ee"
import script from "./Chrono.vue?vue&type=script&lang=js"
export * from "./Chrono.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__